import React from "react";
import Header from "../components/Header";
import Sidebar from "../components/sidebar";
import PartnerEpisodes from "../components/PartnerEpisodes/PartnerEpisodes";

const PartnerEpisodesScreen = ({ match }) => {
  const serieId = match.params.id;

  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <PartnerEpisodes serieId={serieId} />
      </main>
    </>
  );
};

export default PartnerEpisodesScreen;
